import {Icon} from "../atoms/Icon";
import {css} from "@pandacss/css";
import {FC} from "react";
import {Text} from "../style/typography.tsx";
import {createPandaComponent} from "../helpers/pandaComponent.ts";

interface Props {
    text: string,
    icon?: Icon,
    onClick: () => void
}

const panelCss = css({
    background: "neutral.800",
    border: "1px solid",
    borderColor: "neutral.500",
    padding: '20px',
    gap: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: '16px',
    height: "120px"
})

export const ChatHint: FC<Props> = ({text, icon, onClick}) => {
    const IconComponent = icon;
    return <div className={panelCss} onClick={onClick}>
        {IconComponent && <IconComponent size={24} /> }
        {!IconComponent && <div style={{width: 24, height: 24}} />}
        <Text role="description" size="1" weight="regular">{text}</Text>
    </div>
}

// 2x2 grid
const chatHintsGridCss = css({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '12px'
})

export const ChatHints = createPandaComponent('ChatHints', 'div', chatHintsGridCss);